/* @flow */

const getDomain: (url: string) => string = (url) => {
  const parts = url.split('.');
  parts.shift();
  return parts.join('.');
};

const isSameDomain: (domain: string, url: string) => boolean = (domain, url) => getDomain(url) === domain;

const canParseUrl: (url: ?string) => boolean = (url) => {
  if (url === undefined || url === null) {
    return false;
  }

  return URL.canParse(url);
};

export { canParseUrl, isSameDomain };
